/**
 * DataElementsApi
 * DataElementsApi
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DataTypes } from './dataTypes';


export interface DataElementDto { 
    system?: string;
    dataElement?: string;
    status?: string;
    domain?: string;
    component?: string;
    valueTable?: string;
    dataType?: string;
    noChar?: string;
    length?: string;
    shortDescription?: string;
    description?: string;
    heading?: string;
    shortFieldLabel?: string;
    mediumFieldLabel?: string;
    longFieldLabel?: string;
    headingLength?: string;
    shortFieldLabelLength?: string;
    mediumFieldLabelLength?: string;
    longFieldLabelLength?: string;
    dataTypes?: Array<DataTypes>;
}


export const DataElementDtoProps = {
  system: 'system',
  dataElement: 'dataElement',
  status: 'status',
  domain: 'domain',
  component: 'component',
  valueTable: 'valueTable',
  dataType: 'dataType',
  noChar: 'noChar',
  length: 'length',
  shortDescription: 'shortDescription',
  description: 'description',
  heading: 'heading',
  shortFieldLabel: 'shortFieldLabel',
  mediumFieldLabel: 'mediumFieldLabel',
  longFieldLabel: 'longFieldLabel',
  headingLength: 'headingLength',
  shortFieldLabelLength: 'shortFieldLabelLength',
  mediumFieldLabelLength: 'mediumFieldLabelLength',
  longFieldLabelLength: 'longFieldLabelLength',
  dataTypes: 'dataTypes',
} as const;

